import React from "react";
import { useSelector } from "react-redux";
import { useRoles, sectionsToRole } from "../../contexts/RolesContext";
import { selectRole } from "../../features/login/loginSlice";
import { selectActiveType } from "../product/productSlice";

const RoleBasedContent = ({ section, children }) => {
  const roles = useRoles();
  const userRole = useSelector(selectRole); // Ottieni il ruolo dell'utente dallo stato di Redux
  const activeType = useSelector(selectActiveType);
  const allowedRoutes = roles[userRole]?.routesAllowed || [];

  if (userRole.includes("admin") || activeType.includes("missions")) {
    return <>{children}</>;
    
  } else {
    return <></>;
  }
};

export default RoleBasedContent;
